import ModalRoot from './ModalRoot';

export { initialModalState } from './ModalRoot';
export default ModalRoot;
